type RequestSuffix = 'getRepositories' | 'getOrganizations';

export const URL = (suffix: RequestSuffix) =>
	`/gateway/api/devai-core/v1/dev-agents/autoreview-github/${suffix}`;
